import React, { FC, ReactElement } from 'react';
import { WizardPage } from '@buyside/components/presentation/Form/Wizard/Wizard';
import { WizardContextProps } from '@interfaces/wizard/wizard';
import BasicInvestorTypePage from './BasicInvestorTypePage';
import { basicInvestorTypePageSchema } from '@buyside/components/presentation/UserApplication/Helpers/validations';

interface BITCProps {
  isLoading: boolean;
  isRobot: boolean;
  validationSchema: typeof basicInvestorTypePageSchema;
}

const BasicInvestorTypePageContainer: FC<BITCProps> = ({
  validationSchema,
  isLoading,
  isRobot
}): ReactElement => {
  return (
    <WizardPage validationSchema={validationSchema}>
      {({ setFieldValue, setFieldError, values }: WizardContextProps): ReactElement => (
        <BasicInvestorTypePage
          isLoading={isLoading}
          isRobot={isRobot}
          setFieldValue={setFieldValue}
          setFieldError={setFieldError}
          values={values}
        />
      )}
    </WizardPage>
  );
};

export default BasicInvestorTypePageContainer;
